import { DATAGRID_MIN_HEIGHT } from './constants'

export let paperInputSx = {
  '& .MuiInputBase-root': { backgroundColor: 'background.paperDark' },
}

export let dataGridSx = {
  minHeight: DATAGRID_MIN_HEIGHT,
  backgroundColor: 'background.paper',
  border: 1,
  borderRadius: 1,
  borderColor: 'divider',
  '& .MuiDataGrid-cell': {
    borderColor: 'divider',
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: 'background.paperDark',
    borderColor: 'divider',
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: 'background.paperDark',
  },
  '& .MuiDataGrid-footerContainer': {
    borderColor: 'divider',
    backgroundColor: 'background.paperDark',
  },
  '& .MuiDataGrid-iconButtonContainer .MuiIconButton-root': {
    background: 'none !important',
    padding: 0,
  },
  '& .MuiDataGrid-row': {
    '&:hover': {
      backgroundColor: 'background.paperDark',
      cursor: 'pointer',
    },
  },
}

export let largeModalSx = {
  paper: {
    sx: {
      width: { xs: '95vw', sm: '90vw', md: '80vw' },
      height: { xs: '90vh', md: '80vh' },
      maxWidth: 'none',
      maxHeight: 'none',
      borderRadius: 2,
      bgcolor: 'background.default',
    },
  },
}
